<template>
  <div>
    <!-- Header 区域 -->
    <van-nav-bar title="我的反馈" left-arrow @click-left="$router.back()" fixed>
      <template #right>
        <van-icon name="add" @click="onClickRight" />
      </template>
    </van-nav-bar>

    <div class="layout-container">
      <!-- 反馈列表 -->
      <div class="my-content-list" v-if="myCommentList.length > 0">
        <van-swipe-cell
          :before-close="beforeClose"
          v-for="item in myCommentList"
          :key="`notice-${item.noticeId}`"
          :id="item"
        >
          <van-cell>
            <template #title>
              <span class="my-field-type">{{ item.noticeTitle }}</span>
            </template>
            <template #label>
              <div>发布时间：{{ item.createTime }}</div>
            </template>
          </van-cell>
          <template #left>
            <van-button
              square
              type="warning"
              text="修改"
              @click="clickEditFn(item)"
            />
          </template>
          <template #right>
            <van-button
              square
              type="danger"
              text="删除"
              @click="clickDelFn(item)"
            />
          </template>
        </van-swipe-cell>

        <BottomMarker></BottomMarker>
      </div>
      <div v-else>
        <van-empty
          description="暂无内容~"
          :image="require('@/assets/images/empty.png')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { getAriticleListByUserAPI, userProfileAPI, delArticleAPI } from '@/api'
import { Notify } from 'vant'
export default {
  data() {
    return {
      myCommentList: [], // 我的反馈列表
      user: {}
    }
  },

  async created() {
    // // 获取当前用户信息
    // const res_user = await userProfileAPI()
    // console.log('当前用户', res_user)
    // this.user = res_user.data.data
    // this.getMyCommentList()
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.goBack)
  },
  mounted() {
    window.addEventListener('popstate', () => {
      this.goBack();
    })
  },

  methods: {
    goBack() {
      this.$router.push({ path: 'user' })
    },
    // 点击添加按钮事件 - 跳转到我要反馈页面
    onClickRight() {
      this.$toast('此功能暂未开放')
      // this.$router.push('/add_comment')
    },
    // 点击编辑按钮事件 - 携带本条内容跳转到反馈页面进行编辑
    async clickEditFn(item) {
      this.$router.push({ name: 'addComment', params: { item: item } })
    },
    // 点击删除按钮事件
    async clickDelFn(item) {
      // const res_delArticle = await delArticleAPI({ noticeId: item.noticeId })
      // console.log(res_delArticle)
      // if (res_delArticle.data.code !== 200) {
      //   Notify({ type: 'danger', message: '删除反馈失败，请稍后重试！' })
      // } else {
      //   Notify({ type: 'success', message: '删除成功' })
      //   this.getMyCommentList()
      // }
    },
    beforeClose({ position, instance }) {
      switch (position) {
        case 'left':
        case 'right':
        case 'cell':
        case 'outside':
          instance.close()
          break
      }
    },
    // 获取当前用户发布的反馈信息列表
    async getMyCommentList() {
      // const res_myCommentList = await getAriticleListByUserAPI({
      //   noticeType: 5,
      //   createBy: this.user.userName
      // })
      // console.log('反馈列表', res_myCommentList)
      // if (res_myCommentList.data.code !== 200) {
      //   Notify({ type: 'danger', message: '获取我的反馈列表失败' })
      // } else {
      //   this.myCommentList = res_myCommentList.data.rows
      // }
    }
  }
}
</script>
<style lang="less" scoped>
.layout-container {
  margin: 60px 0 20px;
}
/deep/ .van-nav-bar__right {
  font-size: 24px;
  .van-icon-add:before {
    color: #3857eb;
  }
}

.my-content-list {
  .van-cell {
    background: #ffffff;
    margin: 5px 0;
    padding: 10px 10px 15px 10px;
    // border-left: 3px solid #3857eb;
    width: auto;
    .van-cell__title {
      flex: auto;
    }
  }
}
button.van-button.van-button--warning.van-button--normal.van-button--square,
button.van-button.van-button--danger.van-button--normal.van-button--square {
  height: 99%;
}
</style>
